import '../style/voiceInButt.scss';

import {FunctionalComponent, h} from "preact";
import {useContext, useState} from "preact/hooks";
import {IcoMicrophone} from "../components/icons";
import {VoiceContext} from "../effects/voiceContext";
import {log} from "../libs/QuerloLogger";

export const VoiceInButton: FunctionalComponent<{cb: (text: string) => void}> =
    ({cb}) => {

    const [active, setActive] = useState(false);
    const voiceContext = useContext(VoiceContext);
    
    function activate(): void {
        setActive(true);
        voiceContext.speakIn().then( (recognizedText: string): void => {
            log.info('callback to voice in butt', recognizedText);
            if (recognizedText) {
                cb(recognizedText);
            }
            setActive(false);
        } ).catch(() => {
            alert('sorry voice is not supported on this device');
            setActive(false);
        });
    }
    
    return <button type="button"
                   onClick={activate}
                   id="voiceInputBtn">
                {!active && <IcoMicrophone />}
                {active && <span>Recording...</span>}
            </button>
};
